<style>
  .statusBox {
    padding: 10px;
    font-size: 1.2em;
    border: 2px solid #dddddd;
    border-radius: 15px;
    background-color: #ffffff;
  }
  .statusBox.current {
    background-color: var(--colorCal);
    color: #ffffff;
    border: 2px solid #444444;
  }
  .statusBox.notStarted {
    background-color: #cccccc;
    color: #000000;
    border: 2px solid #444444;
  }
  .statusBox.completed {
    background-color: var(--colorDan);
    color: #ffffff;
    border: 1px solid var(--colorCal);
  }
</style>

<div style="display: inline-flex; column-gap: 10px; align-items: center">
  <div class="statusBox completed">
    Working
    <!-- Application | Approved | Live -->
  </div>
  <div>
    <app-icon
      [type]="'ArrowRight'"
      [size]="50"
      [color]="'var(--colorCal)'"
    ></app-icon>
  </div>
  <div class="statusBox current">
    Application
    <!-- Application | Approved | Live -->
  </div>
  <div>
    <app-icon
      [type]="'ArrowRight'"
      [size]="50"
      [color]="'var(--colorCal)'"
    ></app-icon>
  </div>
  <div class="statusBox">
    Approved
    <!-- Application | Approved | Live -->
  </div>
  <div>
    <app-icon
      [type]="'ArrowRight'"
      [size]="50"
      [color]="'var(--colorCal)'"
    ></app-icon>
  </div>
  <div class="statusBox">
    Live
    <!-- Application | Approved | Live -->
  </div>
</div>
